<template>
  <a-spin :spinning="loading">
    <a-form-model ref="form" :model="form" :rules="rules">
      <template>
        <slot name="applicantInfo"></slot>
      </template>

      <a-descriptions title="控件示例" :column="_p.column">
        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item10')">弹出框Size</span>
          </template>
          <a-form-model-item prop="item10">
            <a-select v-model="form.item10" @change="_p.size = form.item10">
              <a-select-option value="smaller">smaller</a-select-option>
              <a-select-option value="small">small</a-select-option>
              <a-select-option value="normal">normal</a-select-option>
              <a-select-option value="big">big</a-select-option>
              <a-select-option value="full">full</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item1')">必填项目</span>
          </template>
          <a-form-model-item prop="item1">
            <a-textarea @keyup.enter.stop v-model="form.item1" :placeholder="$t('disp.ph.input', ['必填项目'])" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item6')">数字输入框</span>
          </template>
          <a-form-model-item prop="item6">
            <a-input-number v-model="form.item6" :min="1" :max="10" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item2')">多选框</span>
          </template>
          <a-form-model-item prop="item2">
            <a-checkbox-group v-model="form.item2" :options="['Apple', 'Pear', 'Orange']" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item3')">日期选择器</span>
          </template>
          <a-form-model-item prop="item3">
            <a-date-picker v-model="form.item3" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item4')">日期范围选择器</span>
          </template>
          <a-form-model-item prop="item4">
            <a-range-picker v-model="form.item4" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item5')">单选框</span>
          </template>
          <a-form-model-item prop="item5">
            <a-radio-group :options="['Apple', 'Pear', 'Orange']" v-model="form.item5" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item9')">JInputPopup</span>
          </template>
          <a-form-model-item prop="item9">
            <j-input-popup
              :showTags="true"
              v-model="form.item9"
              :params="{
                multiFlg: '1',
                departFlg: '1',
                selectUserList: form.item9,
              }"
              component="SelectUserTreeModal"
              :placeholder="$t('disp.ph.select', [$t('disp.participant')])"
            ></j-input-popup>
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item8')">JDictSelectTag</span>
          </template>
          <a-form-model-item prop="item8">
            <j-dict-select-tag
              v-model="form.item8"
              dictCode="notice_type"
              :placeholder="$t('disp.ph.select', [$t('disp.notice.classification')])"
              :triggerChange="true"
            />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item7')">评分</span>
          </template>
          <a-form-model-item prop="item7">
            <a-rate v-model="form.item7" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item11')">滑动输入条</span>
          </template>
          <a-form-model-item prop="item11">
            <a-slider range v-model="form.item11" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item12')">开关</span>
          </template>
          <a-form-model-item prop="item12">
            <a-switch v-model="form.item12" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item13')">时间选择框</span>
          </template>
          <a-form-model-item prop="item13">
            <a-time-picker use24-hours v-model="form.item13" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item14')">树选择</span>
          </template>
          <a-form-model-item prop="item14">
            <a-tree-select
              v-model="form.item14"
              :treeData="$getDepartTree()"
              allowClear
              treeDefaultExpandAll
              placeholder="树选择"
            ></a-tree-select>
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item17')">标签</span>
          </template>
          <a-form-model-item prop="item17">
            <a-tag color="red"> 标签1 </a-tag>
            <a-tag color="orange"> 标签2 </a-tag>
            <a-tag color="blue"> 标签3 </a-tag>
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item18')">进度条</span>
          </template>
          <a-form-model-item prop="item18">
            <a-progress :percent="form.item18" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item>
          <template slot="label">
            <span :class="$isRequired('item19')">文本框</span>
          </template>
          <a-form-model-item prop="item19">
            <a-textarea @keyup.enter.stop placeholder="请填写" v-model="form.item19" />
          </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item v-if="_p.column == 2 || _p.column == 3 || _p.column == 4">
          <template slot="label"> </template>
          <a-form-model-item prop="item19"> </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item v-if="_p.column == 4">
          <template slot="label"> </template>
          <a-form-model-item prop="item19"> </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item v-if="_p.column == 4">
          <template slot="label"> </template>
          <a-form-model-item prop="item19"> </a-form-model-item>
        </a-descriptions-item>

        <a-descriptions-item :span="3">
          <template slot="label">
            <span :class="$isRequired('item16')">JUpload-按钮</span>
          </template>
          <a-form-model-item prop="item16">
            <j-upload bizPath="工作流示例" v-model="form.item16"></j-upload>
          </a-form-model-item>
        </a-descriptions-item>
      </a-descriptions>

      <a-descriptions title="动态table示例" class="no-label">
        <a-descriptions-item>
          <a-table :pagination="false" bordered :dataSource="form.dataSource">
            <a-table-column :width="47" align="center">
              <span slot="title">#</span>
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>

            <a-table-column key="name" data-index="name">
              <span slot="title" :class="$isRequired('name')">可编辑项目</span>
              <template slot-scope="text, record, index">
                <a-form-model-item :prop="`dataSource.${index}.name`" :rules="rules.name">
                  <a-input v-model="form.dataSource[index].name" :placeholder="$t('disp.ph.input', ['可编辑项目'])" />
                </a-form-model-item>
              </template>
            </a-table-column>

            <a-table-column :width="51" align="center">
              <span slot="title">
                <i class="mdi mdi-plus" @click="addRow()"></i>
              </span>
              <template slot-scope="text, record, index">
                <a @click="deleteRow(form.dataSource, index)">删除</a>
              </template>
            </a-table-column>
          </a-table>
        </a-descriptions-item>
      </a-descriptions>

      <template>
        <slot name="applyComment"></slot>
      </template>
    </a-form-model>
  </a-spin>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'

export default {
  name: 'TestApply',
  mixins: [tableMixin],
  components: {},
  props: {},
  data() {
    return {
      // フォーム
      form: {
        item1: '',
        item2: 'Pear',
        item3: '',
        item4: '',
        item5: 'Orange',
        item6: 5,
        item7: 2,
        item8: '',
        item9: '',
        item10: 'normal',
        item11: [20, 50],
        item12: '',
        item13: '',
        item14: '',
        item15: '',
        item16: undefined,
        item17: '',
        item18: 75,
        item19: '',
        item20: '',
        item21: '',
        dataSource: [
          {
            id: '0',
            name: 'Edward King 0',
          },
          {
            id: '1',
            name: '',
          },
        ],
      },
      // 加载中
      loading: false,
      url: {
        saveOrApply: '/TestApply/saveOrApply',
      },
      rules: {
        //item1: [this._r.required],
        //item15: [this._r.required],
        //item16: [this._r.required],
        //name: [this._r.required],
      },
    }
  },
  watch: {
    'form.dataSource': {
      handler(newVal, oldVal) {},
      immediate: false,
      deep: true,
    },
  },
  mounted() {
    // 设置弹出框大小 可选 smaller small normal big full
    this._p.size = 'normal'
  },
  methods: {
    // 临时保存
    handleSave() {
      this._p.excuteSaveOrApply(this.url.saveOrApply, this.form, true)
    },

    // 申请
    handleApply() {
      // 表单验证
      this.$refs.form.validateFieldsAndScroll((ok) => {
        // 验证成功
        if (ok) {
          this._p.excuteSaveOrApply(this.url.saveOrApply, this.form, false)
        }
      })
    },
  },
}
</script>

<style scoped lang="less"></style>
